<template>
    <ion-modal
        ref="aiAssistantModal"
        class="aiAssistant"
        :enter-animation="slideInFromRight"
        :leave-animation="slideOutToRight"
        @didDismiss="onModalDidDismiss"
    >
        <ion-page class="aiAssistantPage">
            <ion-header class="ion-no-border" :translucent="false">
                <ion-toolbar class="ion-no-border" style="--background: var(--ion-color-ai-assitant-bar);border:0" lines="none">
                    <ion-buttons slot="start" lines="none">
                        <ion-button fill="clear" class="aiIcon" lines="none">
                            <ion-img :src="systemVersion == 'pl' ? mhAiLogo : dhAiLogo" slot="icon-only" class="dhAiLogo"></ion-img>
                        </ion-button>
                    </ion-buttons>
                    <ion-title> {{ $t('aiAssistant.assistantGroupName') }}</ion-title>
                    <ion-buttons slot="end" lines="none">
                        <ion-button fill="clear" @click="showAiAssistant('close')" @touchstart.prevent="showAiAssistant('close')" @touchend.prevent="showAiAssistant('close')" lines="none">
                            <ion-icon :icon="closeOutline" slot="start"></ion-icon>
                        </ion-button>
                    </ion-buttons>
                </ion-toolbar>
            </ion-header>
            <ion-content :class="{'bg-transparent': activeThreads === false}" :scroll-events="true" @ionScroll="handleScroll">
                <div class="chatOperation" :class="{ sticky: isChatOperationSticky }">
                    <template v-if="activeThreads === false">
                        <ion-list :toggle-icon="chevronDownOutline" class="bg-transparent ion-no-padding ion-no-margin">
                            <ion-item class="bg-transparent ion-no-padding ion-no-margin" lines="none">
                                <ion-select class="ion-padding-horizontal bg-transparent" aria-label="assistant" interface="action-sheet" :placeholder="$t('aiAssistant.newChat')" @ionChange="startChat($event.target.value)">
                                    <ion-select-option v-for="assistant in assistants" :key="assistant.id" :value="assistant.assistantId">
                                        {{ assistant.name }}
                                    </ion-select-option>
                                </ion-select>
                            </ion-item>
                        </ion-list>
                    </template>
                    <template v-else>
                        <ion-item @click="backToList" lines="none">
                            <ion-icon class="ion-padding-horizontal" :icon="chevronBackOutline"></ion-icon>
                            {{ $t('aiAssistant.backToList') }}
                        </ion-item>
                    </template>

                    <!-- Search Chat -->
<!--                    <ion-item button @click="searchChat" lines="none">-->
<!--                        <ion-icon class="mr-5" :icon="searchOutline"></ion-icon>-->
<!--                        {{ $t('aiAssistant.searchChat') }}-->
<!--                    </ion-item>-->

                </div>

                <div class="aiSeparator"></div>

                <template v-if="activeThreads === false">

                    <!-- Threads Container -->
                    <div class="aiAgentsThreadsContainer">
                        <template v-if="threadsGroup === null">
                            <ion-item lines="none" class="ion-padding threads-loader bg-transparent">
                                <ion-spinner class="bg-transparent" name="circular"></ion-spinner>
                            </ion-item>
                        </template>
                        <template v-else v-for="(groupItem, groupKey, index) in threadsGroup" :key="groupKey">
                            <div v-if="index !== 0" class="aiSeparator"></div>
                            <div class="ion-padding bg-transparent">
                                <ion-list class="m-nav">
                                    <ion-item lines="none" class="pl-4 mb-3">
                                        <ion-label>
                                            <div class="d-flex justify-content-between align-items-center thread-group-header bg-transparent">
                                                <div class="thread-group-header-title">
                                                    {{ groupKey }}
                                                </div>
                                                <div class="thread-group-header-count text-right">
                                                    {{ $t('Total') }}: {{ groupItem.length }}
                                                </div>
                                            </div>
                                        </ion-label>
                                    </ion-item>

                                    <template v-for="item in groupItem" :key="item.threadId">
                                        <ion-item @click="openThread(item.threadId)" class="aiagents-openThread" lines="none">
                                            <ion-label>
                                                <div class="bg-transparent thread-top">
                                                    <ion-icon :icon="item.icons || chatbubbleOutline" slot="start" class="thread-icon" />
                                                    <div class="bg-transparent thread-title">{{ item.assistantName }}</div>
                                                </div>
                                                <div class="bg-transparent thread-preview">
                                                    <span v-if="item.userLastMessage && item.userLastMessage !== ''">
                                                      {{ truncateText(item.userLastMessage, 50) }}
                                                    </span>
                                                    <span v-else>{{ $t('aiAssistant.noConversationYet') }}</span>
                                                </div>
                                            </ion-label>

                                            <ion-buttons slot="end" class="end-actions bg-transparent">
                                                <ion-button class="ellipsis-btn bg-transparent" fill="clear" @click.stop="openSelect(item.threadId)">
                                                    <ion-icon :icon="ellipsisHorizontalOutline"></ion-icon>
                                                </ion-button>

                                                <ion-select
                                                    :ref="el => setSelectRef(item.threadId, el)"
                                                    v-model="selectValues[item.threadId]"
                                                    interface="action-sheet"
                                                    aria-label="assistant"
                                                    label=""
                                                    class="sr-only-select"
                                                    @ionChange="onSelectChange(item.threadId, $event.detail.value)"
                                                >
                                                    <ion-select-option value="delete">
                                                        {{ $t('aiAssistant.delete') }}
                                                    </ion-select-option>
                                                </ion-select>
                                            </ion-buttons>
<!--                                            <ion-buttons class="bg-transparent"  style="padding: 10px;" slot="end">-->
<!--                                                <ion-button class="bg-transparent" fill="clear" @click.stop="openSelect(item.threadId)">-->
<!--                                                    <ion-icon :icon="ellipsisHorizontalOutline"></ion-icon>-->
<!--                                                </ion-button>-->
<!--                                            </ion-buttons>-->
                                        </ion-item>
                                    </template>
                                </ion-list>
                            </div>
                        </template>
                    </div>

                </template>
                <template v-else>
                    <div class="chat-wrapper ion-padding">

                        <div class="chat-messages">
                            <template v-if="loadMessage">
                                <ion-item lines="none" class="ion-padding threads-loader">
                                    <ion-spinner class="bg-transparent" name="circular"></ion-spinner>
                                </ion-item>
                            </template>

                            <div v-else-if="messages.length === 0" class="text-center mt-5">
                                <p class="welcome-text">{{ $t('aiAssistant.noConversationYet') }}</p>
                                <p class="start-now-text">{{ $t('aiAssistant.letsGetStarted') }}</p>
                            </div>

                            <div v-else>
                                <div v-for="(message, index) in messages" :key="message.id">
                                    <!-- Sticky date -->
                                    <div v-if="isNewDate(index)" class="chat-date-sticky">
                                        <div v-if="index === 0">{{ message.assistantName }}</div>
                                        {{ formatDate(message.createdAt) }}
                                    </div>

                                    <!-- Message bubble -->
                                    <div :class="['chat-message-wrapper', message.userSideMessage === '1' ? 'out' : 'in']">
                                        <div class="chat-message-header">
                                            <div class="user-icon">
                                                <ion-avatar v-if="message.userSideMessage === '1' && hasPhoto">
                                                    <img :src="user.photo" @error="onImageError" />
                                                </ion-avatar>
                                                <div v-else-if="message.userSideMessage === '1'" class="user-initial">
                                                    {{ userInitial }}
                                                </div>
                                                <ion-icon v-else :icon="systemVersion == 'pl' ? mhAiLogo : dhAiLogo" size="large"></ion-icon>
                                            </div>
                                            <div class="message-meta">
                                                <div class="user-name">{{ message.userSideMessage === '1' ? user.name : activeThreads.assistantName }}</div>
                                                <div class="message-time">{{ formatDate(message.createdAt)}} {{ formatTime(message.createdAt) }}</div>
                                            </div>
                                        </div>
                                        <div class="chat-message-body">
                                            <template v-if="message.isLoader">
                                                <p class="message-text">
                                                    <ion-spinner class="bg-transparent" name="dots"></ion-spinner>
                                                </p>
                                            </template>
                                            <template v-else>
                                                <p class="message-text" :class="{'message-error': typeof message.error != 'undefined' && message.error}">
                                                    {{ message.message }}
                                                </p>
                                                <div class="message-actions">
                                                    <ion-icon :icon="copyOutline" class="action-icon" @click="copyMessage(message.message)"></ion-icon>
<!--                                                    <span class="send-label">Send</span>-->
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div ref="chatEnd"></div>

                    </div>
                </template>
            </ion-content>
            <ion-footer v-if="activeThreads !== false">
                <div class="ion-padding">
                    <div class="chat-input-wrapper">
                        <template v-if="activeThreads.attachmentEnabled == '1'">
                            <div v-if="attachments.length" class="attachments-row">
                                <ion-chip v-for="(f, i) in attachments" :key="f.__id" outline class="file-chip">
                                    <ion-icon :icon="attachOutline"></ion-icon>
                                    <ion-label>{{ f.name }}</ion-label>
                                    <ion-button fill="clear" class="chip-close" @click="removeAttachment(i)">
                                        <ion-icon :icon="closeOutline"></ion-icon>
                                    </ion-button>
                                </ion-chip>
                            </div>
                        </template>

                        <div class="chat-input-container">
                            <template v-if="activeThreads.attachmentEnabled == '1'">
                                <ion-button fill="clear" class="icon-button rotate-45" @click="triggerFileInput">
                                    <ion-icon :icon="attachOutline"></ion-icon>
                                </ion-button>
                                <input type="file" id="fileInput" hidden multiple @change="onFilesPicked" accept="application/pdf"/>
                            </template>

                            <ion-textarea
                                v-model="inputText"
                                auto-grow
                                :placeholder="$t('aiAssistant.typeHere')"
                                class="chat-textarea"
                                rows="1"
                                @keydown="onKeyDown"
                                @compositionstart="onCompositionStart"
                                @compositionend="onCompositionEnd"
                                enterkeyhint="send"
                            ></ion-textarea>

                            <ion-button fill="clear" class="send-button" @click="sendMessage" :disabled="!canSend">
                                <ion-icon :icon="arrowUpOutline"></ion-icon>
                            </ion-button>
                        </div>
                    </div>
                </div>
                <div class="availableCredit pt-2" :class="{'hasError': balanceErrorMsg !== ''}">
                    <span class="bg-transparent">{{ $t('aiAssistant.balance') }}</span>:
                    <span class="bg-transparent">{{ actualBalance }}</span>
                    <span class="bg-transparent" v-if="balanceErrorMsg !== ''">({{ $t('aiAssistant.balanceError') }}: {{ balanceErrorMsg }})</span>
                </div>
            </ion-footer>
        </ion-page>
    </ion-modal>
</template>

<script>

import {
    IonButtons, IonModal, IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonIcon,
    IonSpinner,
    IonSelect,
    IonChip,
    IonSelectOption ,
    alertController, IonImg, IonButton, IonTextarea
} from "@ionic/vue";
import {
    closeOutline,
    copyOutline,
    attachOutline,
    micOutline,
    arrowUpOutline,
    chevronDownOutline,
    createOutline,
    shareOutline,
    archiveOutline,
    trashOutline,
    searchOutline,
    chevronBackOutline,
    chatbubbleOutline,
    ellipsisHorizontalOutline
} from 'ionicons/icons';
import dhAiLogo from '../../assets/icons/DunaGPT_logo.svg';
import mhAiLogo from '../../assets/icons/MetroGPT_logo.svg';
import { slideInFromRight, slideOutToRight } from "../../js/slideFromRight.js";
import axios from "axios";
import {reactive} from "vue";
import {getSystemVersion} from "@/js/functions";

export default {
    components: {
        IonTextarea,
        IonButton,
        IonImg, IonButtons, IonPage, IonModal,
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonList,
        IonItem,
        IonSpinner,
        IonChip,
        IonSelect,
        IonSelectOption ,
        IonIcon
    },
    props: ['openAIAssistant'],
    data() {
        return {
            hasPhoto: true,
            attachments: [],
            selectRefs: reactive(new Map()),
            selectValues: reactive({}),
            activeDropdown: null,
            dropdownEvent: null,
            isAssistantDropdownOpen: false,
            assistants: [
                { id: 1, name: "Assistant 1" },
                { id: 2, name: "Assistant 2" }
            ],
            threadsGroup: null,
            messages: [],
            systemVersion: getSystemVersion(),
            dhAiLogo,
            mhAiLogo,
            actualBalance: 0,
            balanceErrorMsg: '',
            user: {
                name: null,
                photo: null
            },
            chatbubbleOutline,
            ellipsisHorizontalOutline,
            chevronDownOutline,
            createOutline,
            copyOutline,
            attachOutline,
            micOutline,
            arrowUpOutline,
            shareOutline,
            archiveOutline,
            trashOutline,
            closeOutline,
            searchOutline,
            chevronBackOutline,
            activeThreads: false,
            loadMessage: false,
            inputText: '',
            userInitial: '',
            isRecording: false,
            recognition: null,
            lastScrollTop: 0,
            isChatOperationSticky: false,
            recordingVisible: true,
            isComposing: false,
            aiAgentSelectedThreadRunStatus: {},
            aiAgentSelectedThreadRunId: {},
            waitingForAnswerTimers: {},
            isWaiting: {}
        }
    },
    computed: {
        canSend() {
            return this.inputText.trim().length > 0 || this.attachments.length > 0;
        }
    },
    mounted() {
        this.getLoginDatas();
    },
    methods: {
        async readSSE(res, handlers = {}) {
            const reader = res.body.getReader();
            const decoder = new TextDecoder('utf-8');

            let buffer = '';
            let eventName = 'message';
            let dataLines = [];

            const dispatch = () => {
                if (!dataLines.length) return;
                const raw = dataLines.join('\n');
                dataLines = [];

                let payload = raw;
                try {
                    payload = JSON.parse(raw);
                }
                catch (e) {
                    console.log('Error parsing SSE payload:', raw);
                }

                if (handlers.onEvent) handlers.onEvent({ event: eventName, data: payload, raw });
            };

            let runingWhile = true;
            while (runingWhile) {
                const { value, done } = await reader.read();
                if (done) {
                    runingWhile = false;
                    break;
                }

                buffer += decoder.decode(value, { stream: true });

                let idx;
                while ((idx = buffer.indexOf('\n')) >= 0) {
                    let line = buffer.slice(0, idx);
                    buffer = buffer.slice(idx + 1);
                    if (line.endsWith('\r')) line = line.slice(0, -1);

                    if (line === '') { dispatch(); eventName = 'message'; continue; }
                    if (line.startsWith(':')) continue;

                    if (line.startsWith('event:')) { eventName = line.slice(6).trim() || 'message'; continue; }
                    if (line.startsWith('data:')) { dataLines.push(line.slice(5).trimStart()); continue; }
                }
            }

            dispatch();
            if (handlers.onDone) handlers.onDone();
        },

        getLastAssistantMessageIndex() {
            for (let i = this.messages.length - 1; i >= 0; i--) {
                if (this.messages[i].userSideMessage === '0') return i;
            }
            return -1;
        },

        startStreamingUI() {
            const idx = this.getLastAssistantMessageIndex();
            if (idx < 0) return;
            const m = this.messages[idx];
            m.isLoader = false;
            if (!m.message) m.message = '';
            this.scrollToBottom();
        },

        appendStreamingChunk(chunk) {
            const idx = this.getLastAssistantMessageIndex();
            if (idx < 0) return;
            const m = this.messages[idx];
            if (m.isLoader) {
                m.isLoader = false;
                m.message = '';
            }
            m.message = (m.message || '') + (chunk ?? '');
            this.scrollToBottom();
        },

        finishStreamingUI() {
            this.scrollToBottom();
        },

        /* ---------------- UI + DATA ---------------- */
        onImageError() {
            this.hasPhoto = false;
        },
        onFilesPicked(e) {
            const files = Array.from(e.target.files || []);
            files.forEach(f => (f.__id = `${f.name}-${f.size}-${f.lastModified}-${Math.random()}`));
            const existing = new Set(this.attachments.map(a => `${a.name}-${a.size}-${a.lastModified}`));
            const toAdd = files.filter(f => !existing.has(`${f.name}-${f.size}-${f.lastModified}`));
            this.attachments.push(...toAdd);
            e.target.value = '';

            this.scrollToBottom()
        },
        removeAttachment(index) {
            this.attachments.splice(index, 1);
        },
        setSelectRef(id, el) {
            if (el) this.selectRefs.set(id, el)
            else this.selectRefs.delete(id)
        },
        openSelect(id) {
            const sel = this.selectRefs.get(id)
            if (sel?.open) sel.open()
            else if (sel?.$el?.open) sel.$el.open()
            else if (sel?.setFocus) sel.setFocus()
        },
        onSelectChange(threadId, value) {
            this.threadAction(threadId, value)
            this.selectValues[threadId] = null
        },
        // handleScroll(ev) {
        //     const scrollTop = ev.detail.scrollTop;
        //     this.isChatOperationSticky = (scrollTop < this.lastScrollTop && scrollTop > 50);
        //     this.lastScrollTop = scrollTop;
        // },
        handleScroll() {
            this.isChatOperationSticky = true;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                this.$refs.chatEnd?.scrollIntoView({ behavior: 'auto' });
            });
        },
        getLoginDatas() {
            let selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));
            let loginDatas = JSON.parse(localStorage.getItem('loginDatas'));

            this.user.photo = (selectedIdentity != null) ? selectedIdentity.photo.replace('http://', 'https://') : '';
            this.user.name = (loginDatas != null) ? loginDatas.fullName : '';
            this.userInitial = this.user?.name ? this.user.name.charAt(0).toUpperCase() : 'N/A';
        },
        showAiAssistant(mode = null) {
            this.$emit('show-ai-assistant', mode);
        },

        startChat(assistant) {
            const self = this;
            self.activeThreads = false;
            self.loadMessage = true;
            this.createNewAIAgentThread(assistant, function () {
                self.loadMessage = false;
            });
        },

        async createNewAIAgentThread(agent, callback = null) {
            const self = this;

            const apiURL = this.APIURL('createNewAIAgentThread');
            const errorTitle = this.$t('errorWhileGettingAiData');
            const errorText = this.$t('errorInRequestPleaseTryAgainLater');
            const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));

            axios.post(apiURL, {
                identityId: selectedIdentity.id,
                agent: agent,
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(async function (response) {
                if (typeof response.data != 'undefined' && typeof response.data.result != 'undefined' && typeof response.data.status != 'undefined') {
                    if (response.data.status == 'error') {
                        let alert = await alertController.create({
                            header: errorTitle,
                            message: response.data.message,
                            buttons: ['OK'],
                        });
                        alert.present();
                    } else {
                        self.loadMessage = true;
                        self.loadAiData({ assistants: 1, threads: 1 }, function () {
                            self.loadMessage = false;
                            self.openThread(response.data.result);
                        });
                    }
                } else {
                    let alert = await alertController.create({
                        header: errorTitle,
                        message: errorText,
                        buttons: ['OK'],
                    });
                    alert.present();
                }
                self.loaderOpened = false;

                if (callback != null) {
                    callback(response);
                }
            });
        },

        backToList() {
            const self = this;
            self.activeThreads = false;
            self.loadMessage = true;
            this.loadAiData({ assistants: 1, threads: 1 }, function () {
                self.loadMessage = false;
            });
        },
        searchChat() {
            const self = this;
            self.activeThreads = false;
            self.loadMessage = true;
            this.loadAiData({ assistants: 1, threads: 1 }, function () {
                self.loadMessage = false;
            });
        },
        openThread(thread) {
            const self = this;
            self.activeThreads = self.findThreadById(thread);
            self.loadMessage = true;
            self.messages = [];
            this.loadAiData({ messages: thread }, function () {
                self.loadMessage = false;
            });
        },
        findThreadById(threadId) {
            for (const key in this.threadsGroup) {
                if (Array.isArray(this.threadsGroup[key])) {
                    const found = this.threadsGroup[key].find(item => item.threadId === threadId);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        },
        threadAction(threadId, mode) {
            if (typeof mode == 'undefined' || mode === '') return false;

            const self = this;

            const apiURL = this.APIURL('modifyThread');
            const errorTitle = this.$t('errorWhileGettingAiData');
            const errorText = this.$t('errorInRequestPleaseTryAgainLater');
            const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));

            self.loaderOpened = true;

            axios.post(apiURL, {
                identityId: selectedIdentity.id,
                mode: mode,
                threadId: threadId,
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(async function (response) {
                if (typeof response.data != 'undefined' && typeof response.data.result != 'undefined' && typeof response.data.status != 'undefined') {
                    if (response.data.status == 'error') {
                        let alert = await alertController.create({
                            header: errorTitle,
                            message: response.data.message,
                            buttons: ['OK'],
                        });
                        alert.present();
                    } else {
                        self.loadMessage = true;
                        self.loadAiData({ assistants: 1, threads: 1 }, function () {
                            self.loadMessage = false;
                        });
                    }
                } else {
                    let alert = await alertController.create({
                        header: errorTitle,
                        message: errorText,
                        buttons: ['OK'],
                    });
                    alert.present();
                }
                self.loaderOpened = false;
            });
        },
        truncateText(text, length) {
            return text.length > length ? text.substring(0, length) + "..." : text;
        },
        formatDate(dateStr) {
            return new Date(dateStr).toLocaleDateString();
        },
        formatTime(dateStr) {
            return new Date(dateStr).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
        isNewDate(index) {
            if (index === 0) return true;
            const current = new Date(this.messages[index].createdAt).toDateString();
            const previous = new Date(this.messages[index - 1].createdAt).toDateString();
            return current !== previous;
        },
        async copyMessage(text) {
            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(text);
                    await this.presentToast('Vágólapra másolva!');
                    return;
                } catch (e) {
                    console.error('Failed to copy to clipboard');
                }
            }

            try {
                const ta = document.createElement('textarea');
                ta.value = text;
                ta.setAttribute('readonly', '');
                ta.style.position = 'absolute';
                ta.style.left = '-9999px';
                ta.style.top = '0';
                ta.style.fontSize = '16px';
                document.body.appendChild(ta);

                const selection = document.getSelection();
                const originalRange = selection && selection.rangeCount ? selection.getRangeAt(0) : null;

                ta.focus();
                ta.select();
                ta.setSelectionRange(0, ta.value.length);

                const ok = document.execCommand('copy');
                document.body.removeChild(ta);

                if (selection) {
                    selection.removeAllRanges();
                    if (originalRange) selection.addRange(originalRange);
                }

                if (!ok) throw new Error('execCommand returned false');
                await this.presentToast('Vágólapra másolva!');
            } catch (e) {
                console.error('Copy failed:', e);
                await this.presentToast('Nem sikerült a másolás.', 'danger');
            }
        },

        async presentToast(message, color = 'success') {
            const { toastController } = await import('@ionic/vue');
            const toast = await toastController.create({
                message,
                duration: 1600,
                color,
                position: 'bottom',
                icon: color === 'success' ? 'clipboard-outline' : 'alert-circle-outline'
            });
            await toast.present();
        },
        triggerFileInput() {
            document.getElementById('fileInput')?.click();
        },

        sendMessage() {
            const text = this.inputText.trim();
            if (!text && this.attachments.length === 0) return;
            this.messages.push({
                id: Date.now(),
                userSideMessage: '1',
                message: text,
                createdAt: new Date().toISOString(),
            });

            this.messages.push({
                id: Date.now() + 1,
                userSideMessage: '0',
                message: null,
                isLoader: true,
                createdAt: new Date().toISOString(),
            });
            const filesToSend = this.attachments.slice();
            this.inputText = '';
            this.attachments = [];

            this.scrollToBottom();

            this.sendAIAgentMessage(this.activeThreads.threadId, text, filesToSend);

            this.scrollToBottom();
        },

        onKeyDown(e) {
            if (e.key !== 'Enter') return;

            if (e.isComposing || this.isComposing) return;

            if (e.shiftKey) {
                return;
            }

            e.preventDefault();
            this.sendMessage();
        },

        onCompositionStart() {
            this.isComposing = true;
        },
        onCompositionEnd() {
            this.isComposing = false;
        },
        setErrorMessageToAi(threadId, message) {
            let self = this;
            this.loadAiData({ messages: threadId }, function () {
                self.messages.push({
                    id: Date.now(),
                    userSideMessage: '0',
                    error: true,
                    message: message,
                    createdAt: new Date().toISOString(),
                });
            });
        },
        async sendAIAgentMessage(threadId, message, files = []) {
            const self = this;
            const sendURL = this.APIURL('sendAIAgentMessage');
            const waitURL = this.APIURL('waitingToAnswer');
            const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));

            try {
                const st = self.aiAgentSelectedThreadRunStatus[threadId];
                if (st != null && st !== 'completed' && st !== 'cancelled') {
                    return false;
                }

                self.aiAgentSelectedThreadRunStatus[threadId] = 'message_sent';

                const form = new FormData();
                form.append('identityId', selectedIdentity.id);
                form.append('threadId', threadId);
                form.append('message', message ?? '');
                files.forEach(f => form.append('files[]', f, f.name));

                const res = await fetch(sendURL, {
                    method: 'POST',
                    body: form
                });

                if (!res.ok) throw new Error(`HTTP ${res.status}`);

                const ct = (res.headers.get('content-type') || '').toLowerCase();

                if (ct.includes('text/event-stream')) {
                    let finalizeCalled = false;
                    let streamingStarted = false;

                    await this.readSSE(res, {
                        onEvent: ({ data }) => {
                            if (!data || typeof data !== 'object') return;

                            if (data.type === 'content') {
                                if (!streamingStarted) {
                                    streamingStarted = true;
                                    self.startStreamingUI();
                                }
                                if (typeof data.content === 'string') {
                                    self.appendStreamingChunk(data.content);
                                }
                                return;
                            }

                            if (data.type === 'error') {
                                streamingStarted = false;
                                self.finishStreamingUI();
                                self.aiAgentSelectedThreadRunStatus[threadId] = 'error';
                                self.aiAgentSelectedThreadRunId[threadId] = null;
                                self.setErrorMessageToAi(threadId, data.message || self.$t('aiAssistant.errorWhileSendingMessage'));
                                return;
                            }

                            if (data.type === 'done') {
                                streamingStarted = false;
                                self.finishStreamingUI();
                                if (finalizeCalled) return;
                                finalizeCalled = true;

                                const _threadId = data.threadId || threadId;
                                const _runId = data.runId || null;
                                const _messageId = data.messageId || null;

                                self.aiAgentSelectedThreadRunStatus[_threadId] = 'completed';
                                self.aiAgentSelectedThreadRunId[_threadId] = null;

                                if (typeof data.availableCredit !== 'undefined' && typeof data.availableCredit.credit !== 'undefined') {
                                    self.actualBalance = data.availableCredit.credit;
                                }

                                if (_runId) self.aiAgentSelectedThreadRunId[_threadId] = _runId;

                                if (!_runId) {
                                    self.aiAgentSelectedThreadRunStatus[_threadId] = 'completed';
                                    if (self.activeThreads && self.activeThreads.threadId === _threadId) {
                                        self.loadAiData({ messages: _threadId });
                                    }
                                    return;
                                }

                                const waitForm = new FormData();
                                waitForm.append('threadId', _threadId);
                                waitForm.append('runId', _runId);
                                if (_messageId) waitForm.append('messageId', _messageId);
                                waitForm.append('identityId', selectedIdentity.id);

                                fetch(waitURL, { method: 'POST', body: waitForm })
                                    .then(r => r.json())
                                    .then((waitJson) => {
                                        const answerData = waitJson?.result;
                                        const status = answerData?.status;
                                        if (status) self.aiAgentSelectedThreadRunStatus[_threadId] = status;

                                        if (typeof answerData?.availableCredit !== 'undefined' && typeof answerData.availableCredit.credit !== 'undefined') {
                                            self.actualBalance = answerData.availableCredit.credit;
                                        }

                                        if (['completed', 'error', 'cancelled'].includes(status)) {
                                            self.aiAgentSelectedThreadRunId[_threadId] = null;
                                        }

                                        if (self.activeThreads && self.activeThreads.threadId === _threadId) {
                                            self.loadAiData({ messages: _threadId });
                                        } else {
                                            self.loadAiData({ threads: 1 });
                                        }
                                    })
                                    .catch(() => {
                                        if (self.activeThreads && self.activeThreads.threadId === _threadId) {
                                            self.loadAiData({ messages: _threadId });
                                        }
                                    });

                                return;
                            }
                        },
                        onDone: () => {
                            self.finishStreamingUI();
                            if (!finalizeCalled) {
                                finalizeCalled = true;
                                self.aiAgentSelectedThreadRunStatus[threadId] = 'completed';
                                self.aiAgentSelectedThreadRunId[threadId] = null;
                                if (self.activeThreads && self.activeThreads.threadId === threadId) {
                                    self.loadAiData({ messages: threadId });
                                }
                            }
                        }
                    });

                    return;
                }

                let json = null;
                try { json = await res.json(); } catch { json = null; }
                const runData = json?.result;
                if (!runData) throw new Error('Invalid response');

                let _threadId = runData.threadId;
                let _runId = runData.runId;
                let _messageId = runData.messageId;
                self.aiAgentSelectedThreadRunId[threadId] = _runId;

                if(_runId == null) {
                    self.aiAgentSelectedThreadRunStatus[threadId] = 'error';
                    self.aiAgentSelectedThreadRunId[threadId] = null;
                    self.setErrorMessageToAi(threadId, self.$t('aiAssistant.errorWhileSendingMessage'));
                    return;
                }

                if(typeof runData.availableCredit != 'undefined' && typeof runData.availableCredit.credit != 'undefined') {
                    self.actualBalance = runData.availableCredit.credit;
                }

                self.isWaiting[_threadId] = false;

                self.waitingForAnswerTimers[_threadId] = setInterval(async function () {
                    if (self.isWaiting[_threadId]) return;
                    self.isWaiting[_threadId] = true;

                    try {
                        const waitForm = new FormData();
                        waitForm.append('threadId', _threadId);
                        waitForm.append('runId', _runId);
                        waitForm.append('messageId', _messageId);
                        waitForm.append('identityId', selectedIdentity.id);

                        const waitRes = await axios.post(waitURL, waitForm, {
                            headers: { 'Content-Type': 'multipart/form-data' },
                        });

                        const answerData = waitRes.data.result;
                        self.aiAgentSelectedThreadRunStatus[threadId] = answerData.status;

                        if (['completed','error','cancelled'].includes(answerData.status)) {
                            self.aiAgentSelectedThreadRunId[threadId] = null;
                            clearInterval(self.waitingForAnswerTimers[_threadId]);
                            if(self.activeThreads.threadId == _threadId) {
                                self.loadAiData({ messages: _threadId });
                            }
                        }
                    } catch (err) {
                        self.aiAgentSelectedThreadRunStatus[threadId] = 'error';
                        self.aiAgentSelectedThreadRunId[threadId] = null;
                        if(self.activeThreads.threadId == _threadId) {
                            self.loadAiData({ messages: _threadId });
                        }
                    } finally {
                        self.isWaiting[_threadId] = false;
                    }
                }, 1000);
            } catch (e) {
                console.error('Error while sending AI data:', e);
                self.setErrorMessageToAi(threadId, 'Error while sending AI data:' + e.message);
                self.aiAgentSelectedThreadRunStatus[threadId] = 'error';
                self.aiAgentSelectedThreadRunId[threadId] = null;
            }
        },
        async loadAiData({assistants = 0, threads = 0, messages = "", loadBalance = 0} = {}, callback = null) {
            let self = this;
            const apiURL = this.APIURL('loadAiAgents');
            const errorTitle = this.$t('errorWhileGettingAiData');
            const errorText = this.$t('errorInRequestPleaseTryAgainLater');
            const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));

            axios.post(apiURL, {
                identityId: selectedIdentity.id,
                get_assistants : assistants,
                get_threads : threads,
                get_messages : messages,
                get_balance : loadBalance,
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(async function(response) {
                if (typeof response.data != 'undefined' && typeof response.data.result.threadsGroup != 'undefined' && typeof response.data.status != 'undefined') {
                    if (response.data.status == 'error') {
                        let alert = await alertController.create({
                            header: errorTitle,
                            message: response.data.message,
                            buttons: ['OK'],
                        });
                        alert.present();
                    } else {
                        if(typeof response.data.result.threadsGroup != 'undefined') {
                            self.threadsGroup = response.data.result.threadsGroup;
                        }
                        if(typeof response.data.result.messages != 'undefined' && response.data.result.messages != null) {
                            if(response.data.result.messages.length > 0) {
                                self.messages = response.data.result.messages;
                                setTimeout(() => self.scrollToBottom(), 100);
                            }
                        }
                        if(typeof response.data.result.assistants != 'undefined' && response.data.result.assistants != null) {
                            if(response.data.result.assistants.length > 0) {
                                self.assistants = response.data.result.assistants;
                            }
                        }
                    }

                    if(typeof response.data.result.availableCredit != 'undefined' && typeof response.data.result.availableCredit.credit != 'undefined') {
                        self.actualBalance = response.data.result.availableCredit.credit;
                    }
                } else {
                    let alert = await alertController.create({
                        header: errorTitle,
                        message: errorText,
                        buttons: ['OK'],
                    });
                    alert.present();
                }
                // self.loaderOpened = false;
                if(callback != null) {
                    callback(response);
                }
            });
        },
        onModalDidDismiss() {
            this.$emit('show-ai-assistant', 'close');
        }
    },
    watch: {
        openAIAssistant() {
            if (this.openAIAssistant) {
                this.$refs.aiAssistantModal.$el.present();
                this.loadAiData({assistants: 1, threads: 1, loadBalance: 1}, function() {
                    // console.log("AI Assistant loaded");
                });
            } else {
                this.$refs.aiAssistantModal.$el.dismiss(null, 'cancel');
            }
        }
    },
    setup() {
        return {
            slideInFromRight,
            slideOutToRight
        }
    }
}
</script>

<style scoped>
:root {
    --ion-header-background: transparent;
    --ion-toolbar-background:transparent;
    --inner-padding-end: 0;
}
.aiAssistantPage {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: var(--ion-color-ai-assitant-bar) !important;
}

.aiAssistantPage ion-header {
    background-color: var(--ion-color-ai-assitant-bar) !important;
    transition: transform 0.3s ease;
    z-index: 10;
}

.chatOperation.sticky {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: var(--ion-color-ai-assitant-bar);
    transition: box-shadow 0.2s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}

.aiAssistant .threads-loader ion-spinner {
    margin: auto;
    color: var(--ion-color-ai-assitant-primary) !important;
}
.aiAssistant .dropdown-list {
    margin-left: 20px;
    border-left: 2px solid var(--ion-color-medium);
    padding-left: 10px;
}

.aiAssistant .aiAgentsThreadsContainer {
    padding: 0;
}

.aiAssistant .m-nav {
    padding: 0;
    margin-bottom: 20px;
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
}

.aiAssistant .thread-top {
    display: flex;
}

.aiAssistant .thread-top ion-icon{
    margin-right: 5px;
}

.aiAssistant .thread-group-header {
    font-size: 14px;
    font-weight: bold;
    color: var(--ion-color-ai-assitant-font);
    display: flex;
    justify-content: space-between;
    text-transform: capitalize;
    background-color: transparent;
}

.aiAssistant .thread-group-header-title {
    font-weight: 700;
    font-size: 14px;
    color: var(--ion-color-ai-assitant-primary);
    background: transparent !important;
}

.aiAssistant .thread-group-header-count {
    font-weight: 400;
    font-size: 14px;
    color: var(--ion-color-ai-assitant-primary);
    background: transparent !important;
}

.aiAssistant .aiSeparator {
    height: 1px;
    border-bottom: 1px solid var(--ion-color-ai-assitant-separator);
}

.aiAssistant .aiagents-openThread {
    --padding-start: 12px;
    --inner-padding-end: 4px;
    --min-height: 60px;
}

.aiAssistant .thread-icon {
    font-size: 18px;
    color: var(--ion-color-ai-assitant-primary);
}

.aiAssistant .thread-title {
    padding-bottom: 5px;
    font-size: 12px;
    color: var(--ion-color-ai-assitant-primary);
}

.aiAssistant .thread-date {
    padding-bottom: 5px;
    font-weight: 400;
    font-size: 12px;
    color: var(--ion-color-ai-assitant-primary);
}

.aiAssistant .thread-preview {
    background-color: transparent;
    font-weight: 600;
    font-size: 14px;
    color: var(--ion-color-ai-assitant-primary);
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.aiAssistant .thread-preview span{
    background-color: transparent !important;
}

.aiAssistant .aiagents-openThread ion-button {
    margin-inline-start: 0;
}
.aiAssistant .thread-icon {
    font-size: 16px !important;
}


.aiAssistant {
    position: absolute;
    z-index: 9999;
    --width: 90% !important;
    --height: 100% !important;
    justify-content: flex-end !important;
    padding-top: 0;
    padding-bottom: 0;
}

.aiAssistant ion-header ion-toolbar,
.aiAssistant ion-header ion-toolbar ion-title,
.aiAssistant ion-header ion-toolbar ion-label,
.aiAssistant ion-header ion-toolbar ion-button,
.aiAssistant ion-header ion-toolbar ion-buttons,
.aiAssistant ion-header ion-toolbar ion-img,
.aiAssistant ion-header ion-toolbar ion-icon {
    background: transparent!important;
}

.aiAssistant ion-content {
    border: 0 !important;
}

.aiAssistant .background-content {
    background: transparent!important;
}

.tmp.chat-wrapper {
    background-image: url('../../assets/icons/DunaGPT_bg.svg');
    background-repeat: no-repeat;
    background-position: center 70%;
    background-size: auto;
    min-height: 100vh;
    background-color: #fff !important;
}

.aiAssistant ion-title, .aiAssistant ion-title slot {
    color: var(--ion-color-ai-assitant-primary) !important;
}

.aiAssistant ion-item {
    color: var(--ion-color-ai-assitant-primary) !important;
}

.aiAssistant ion-item:hover, .aiAssistant ion-item:focus {
    color: var(--ion-color-ai-assitant-primary) !important;
    --background: var(--ion-color-ai-assitant-hover-2) !important;
    --background-hover: transparent !important;
}

.aiAssistant button {
    color: var(--ion-color-ai-assitant-primary-button) !important;
}

.aiAssistant ion-header:after {
    display: none !important;
}

.aiAssistant .message-text {
    border-radius: 16px;
    padding: 16px;
    font-weight: 400;
    font-size: 14px;
}

.aiAssistant .chat-message-wrapper.in .message-text {
    background-color: #F2F5F8 !important;
    color: black;
}

.aiAssistant .chat-message-wrapper.out .message-text {
    background-color: var(--ion-color-ai-assisant-message-buble-out) !important;
    color: var(--ion-color-ai-assisant-message-buble-text-out);
}

.aiAssistant .chat-message-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    align-items: flex-start;
}

.aiAssistant .chat-container {
    padding: 1rem;
}

.aiAssistant .chat-date-sticky {
    text-align: center;
    font-size: 0.8rem;
    color: #aaa;
    margin: 1rem 0;
}

.aiAssistant .chat-message-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.aiAssistant .user-icon ion-avatar {
    width: 36px;
    height: 36px;
}


.aiAssistant .user-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
}

.aiAssistant .user-initial {
    background: var(--ion-color-ai-assitant-bar) !important;
    color: var(--ion-color-ai-assitant-primary);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 12px;
}

.aiAssistant .message-meta {
    font-size: 0.8rem;
    color: #666;
}

.aiAssistant .user-name {
    display: inline-block;
    font-weight: 700;
    font-size: 12px;
    color: var(--ion-color-ai-assitant-primary);
    margin-left: 0.5rem;
}

.aiAssistant .message-time {
    display: inline-block;
    font-weight: 400;
    font-size: 12px;
    background: var(--ion-color-ai-assitant-time);
    margin-left: 0.5rem;

}

.aiAssistant .chat-message-body {
    background: #f1f1f1;
    border-radius: 10px;
    max-width: 70%;
    position: relative;
}

.aiAssistant .px-4 {
    padding-left: 1.0rem !important;
    padding-right: 1.0rem !important;
}

.aiAssistant .message-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}

.aiAssistant .message-actions .send-label {
    font-weight: 600;
    font-size: 10px;
    color: var(--ion-color-ai-assitant-primary);
}

.aiAssistant .message-actions .action-icon {
    color: var(--ion-color-ai-assitant-primary);
}

.aiAssistant .chat-footer {
    --border-width: 0;
    padding: 8px;
    background: #fff;
}

.aiAssistant .chat-input-container {
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid var(--ion-color-ai-assitant-input-border);
    border-radius: 30px;
    padding: 6px 12px;
    gap: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.aiAssistant .chat-textarea {
    flex: 1 !important;
    min-width: 0 !important;
    width: 100% !important;
    --background: transparent;
    --padding-start: 0;
    --padding-end: 0;
    --padding-top: 6px;
    --padding-bottom: 6px;
    resize: none;
    line-height: 1.2;
    display: inline-block;
    align-items: center;
    height: 100%;
}

.aiAssistant .chat-textarea textarea {
    width: 100% !important;
}

.aiAssistantContent {
    --height: calc(100% - 120px) !important;
}

.chat-input-wrapper {
    background: #fff;
}

.chat-input-container {
    display: flex;
    align-items: center;
    background: white;
    border: 1px solid #0a58ca;
    border-radius: 999px;
    padding: 6px 12px;
    gap: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.chat-textarea {
    flex: 1;
    font-size: 14px;
    --background: transparent;
    --padding-start: 0;
    --padding-end: 0;
    --padding-top: 6px;
    --padding-bottom: 6px;
    resize: none;
    line-height: 1.4;
    min-height: 32px;
    display: flex;
    align-items: center;
    height: 100%;
}

.aiAssistant .icon-button {
    --padding-start: 4px;
    --padding-end: 4px;
    min-width: 32px;
    height: 32px;
    font-size: 24px;
    color: var(--ion-color-ai-assitant-primary);
}

.aiAssistant .icon-button.rotate-45 {
    transform: rotate(45deg);
}

.aiAssistant .send-button {
    --padding-start: 4px;
    --padding-end: 4px;
    min-width: 32px;
    height: 32px;
    font-size: 24px;
    background-color: var(--ion-color-ai-assitant-primary-button) !important;
    border-radius: 50%;
}

.aiAssistant .send-button ion-icon {
    font-size: 18px;
    background-color: var(--ion-color-ai-assitant-primary-button) !important;
    color: white;
}

.icon-button.recording {
    background-color: red !important;
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
    animation: pulse 1.5s infinite, pulseScale 1.5s infinite;
    border-radius: 50%;
    transition: background-color 0.3s ease;
}

.icon-button.recording ion-icon {
    background-color: red !important;
    color: white !important;
    transition: color 0.3s ease;
}

@keyframes pulseScale {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    }
}

.chatOperation, .aiAgentsThreadsContainer {
    background-color: var(--ion-color-ai-assitant-bar) !important;
}

.chatOperation ion-item {
    font-weight: 700;
    font-size: 14px;
}

.chatOperation ion-item, .chatOperation ion-icon,
.aiAgentsThreadsContainer ion-item, .aiAgentsThreadsContainer ion-icon, .aiAgentsThreadsContainer ion-label, .aiAgentsThreadsContainer ion-list,
.bg-transparent {
    background-color: transparent !important;
}

.chatOperation ion-icon {
    color: var(--ion-color-ai-assitant-primary) !important;
}

.chatOperation .mr-5 {
    margin-right: 5px !important;
}

.chatOperation .ml-5 {
    margin-left: 5px;
}

.aiAssistant ion-popover {
    z-index: 9999 !important;
}
.aiAssistant ion-popover::part(content) {
    background: #fff !important;
    color: #000 !important;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 0 !important;
}

.aiAssistant ion-popover ion-list {
    padding: 0;
    margin: 0;
}

.aiAssistant ion-popover ion-item {
    --background: transparent !important;
    --color: #000 !important;
    font-size: 14px;
}

.thread-dropdown-menu {
    right: 12px;
    z-index: 100;
    background: white;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border-left: 1px solid var(--ion-color-ai-assitant-hover-2);
    border-right: 1px solid var(--ion-color-ai-assitant-hover-2);
    border-bottom: 1px solid var(--ion-color-ai-assitant-hover-2);
}

.thread-dropdown-menu ion-item {
    padding: 0 16px;
    --padding-start: 12px;
    --inner-padding-end: 8px;
    --min-height: 44px;
    font-size: 14px;
    border-bottom: 1px solid var(--ion-color-ai-assitant-hover-2);
    color: var(--ion-color-ai-assitant-primary);
}

.thread-dropdown-menu ion-item:last-child {
    border-bottom: 0;
}

.thread-dropdown-menu ion-item:hover {
    --background: var(--ion-color-ai-assitant-hover-2);
}

.thread-dropdown-menu ion-icon {
    font-size: 16px;
    margin-right: 8px;
    color: var(--ion-color-ai-assitant-primary);
}
.aiAssistant ion-select::part(placeholder) {
    opacity: 1 !important;
}

.sr-only-select {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
}

ion-footer {
    border-top: 1px solid var(--ion-color-ai-assitant-separator);
}

.welcome-text {
    font-weight: 400;
    font-size: 16px;
    color: var(--ion-color-ai-assitant-primary);
}

.start-now-text {
    font-weight: 600;
    font-size: 16px;
    color: var(--ion-color-ai-assitant-primary);
}
.attachments-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 6px 2px 10px 2px;
    overflow: visible;
    align-items: flex-start;
}

.file-chip {
    flex: 0 0 auto;
    --background: #fff;
    --color: var(--ion-color-ai-assitant-primary);
    border: 1px solid var(--ion-color-ai-assitant-separator);
    border-radius: 999px;
    height: auto;
    padding: 4px 6px;
}

.file-chip ion-label {
    white-space: normal;
    overflow-wrap: anywhere;
    line-height: 1.2;
}

.file-chip .chip-close {
    --padding-start: 4px;
    --padding-end: 0;
    height: 20px;
    min-width: 20px;
    margin-left: 6px;
}

.message-attachments {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.aiAssistant .chat-message-wrapper.in .message-text.message-error {
    background-color: var(--ion-color-ai-assitant-error) !important;
    color: white !important;
}

.sc-ion-textarea-md-h {
    margin-top: 4px;
}

.message-text {
    white-space: pre-line;
}

.dhAiLogo, .mhAiLogo {
    pointer-events: none;
}

.aiIcon {
    min-width: 44px;
    min-height: 44px;
}

.aiagents-openThread ion-buttons.end-actions {
    align-self: stretch;
    height: 100%;
    padding: 0;
}

.aiagents-openThread .ellipsis-btn {
    height: 100%;
    margin: 0;
    padding: 0 10px;
    --border-radius: 0;
    --background: transparent;
    --background-hover: rgba(0,0,0,0.06);
    --background-activated: rgba(0,0,0,0.08);
}

.aiagents-openThread .ellipsis-btn ion-icon {
    pointer-events: none;
}
</style>
